export default {
  title: "Select background color",
  labels: {
    r: "R:",
    g: "G:",
    b: "B:",
    hex: "HEX:"
  },
  buttons: {
    cancel: "Cancel",
    apply: "Apply"
  }
}
